import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M790.588235,959.588235 L1016.47059,959.588235 L1016.47059,733.705882 L790.588235,733.705882 L790.588235,959.588235 Z M1129.41176,1298.41176 L1355.29412,1298.41176 L1355.29412,1072.52941 L1129.41176,1072.52941 L1129.41176,1298.41176 Z M790.588235,1298.41176 L1016.47059,1298.41176 L1016.47059,1072.52941 L790.588235,1072.52941 L790.588235,1298.41176 Z M451.764706,1298.41176 L677.647059,1298.41176 L677.647059,1072.52941 L451.764706,1072.52941 L451.764706,1298.41176 Z M451.764706,959.588235 L677.647059,959.588235 L677.647059,733.705882 L451.764706,733.705882 L451.764706,959.588235 Z M1355.29412,281.941176 L1355.29412,733.705882 L1807.05882,733.705882 L1807.05882,1637.23529 L112.941176,1637.23529 L112.941176,281.941176 L1355.29412,281.941176 Z M1468.23529,305.32 L1783.68,620.764706 L1468.23529,620.764706 L1468.23529,305.32 Z M1870.41882,547.804706 L1541.19529,218.581176 C1509.68471,187.070588 1465.97647,169 1421.47765,169 L5.68434189e-14,169 L5.68434189e-14,1750.17647 L1920,1750.17647 L1920,667.522353 C1920,622.345882 1902.38118,579.767059 1870.41882,547.804706 L1870.41882,547.804706 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMsExcelLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMsExcelLine, _Component);

  var _super = _createSuper(IconMsExcelLine);

  function IconMsExcelLine() {
    _classCallCheck(this, IconMsExcelLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMsExcelLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMsExcel",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMsExcelLine.displayName = "IconMsExcelLine";
  return IconMsExcelLine;
}(Component);

IconMsExcelLine.glyphName = 'ms-excel';
IconMsExcelLine.variant = 'Line';
IconMsExcelLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMsExcelLine;
export { IconMsExcelLine };